
import PropTypes from "prop-types"
import { Form } from "antd"
import { noEmptyStringValidator } from "../../utility/forms"
import { useDictionaryTranslation } from "../../hooks/useDictionaryTranslation";
import { sanitizeIdentification } from "../../utility/finalCustomerUtils";

export const IdentificationFormItem = ({ initialValue, children, disabled, isAutogenerated }) => {
  const { translate: t } = useDictionaryTranslation();
  return (
    <Form.Item
      initialValue={initialValue}
      name="identification"
      disabled={disabled}
      getValueFromEvent={(e) => sanitizeIdentification(e.target.value)}
      rules={[{ min: 3, required: isAutogenerated ?? true, validator: noEmptyStringValidator, message: t('identificationRequired') }]}
      label={t('identification')}
    >
      {children}
    </Form.Item>
  )

}

IdentificationFormItem.propTypes = {
  initialValue: PropTypes.string,
  children: PropTypes.node.isRequired,
  disabled: PropTypes.bool,
  isAutogenerated: PropTypes.bool,
}